var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-dialog',[_c('div',{staticClass:"dialog-wrapper dialog-readtip-wrapper"},[_c('div',{staticClass:"no-box"},[_c('img',{attrs:{"src":require('@/assets/imgs/answer/no.png')}}),_c('p',[_vm._v("别灰心，还有更多精彩活动等你参与呢~")])]),_c('button',{staticClass:"dialog-btn-submit",on:{"click":_vm.onClose}},[_vm._v("我知道了")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }